<template>
  <va-card :title="$t('orders.listTitle')">
    <div class="row flex-end">
      <div class="mr-auto flex sm12 xl4 xs12">
        <va-input v-model="searchValue" :label="!searchBy ? $t('orders.searchValue') : ''" :style="{ width: '100%' }"
          :disabled="!searchBy" :placeholder="
            !searchBy ? $t('orders.selectSearchBy') : $t('orders.searchValue')
          ">
          <va-select class="serchby" slot="prepend" :label="$t('orders.searchBy')" v-model="searchBy"
            :clearValue="{ name: '' }" @input="searchValue = ''" :options="[
              'lender_name',
              'borrower_name',
            ]" />
        </va-input>
      </div>
      <div class="ml-auto flex sm6 md4 xl3 xs12">
        <va-select :label="$t('orders.status')" v-model="filterByStatus" textBy="title" keyBy="status"
          :clearValue="{ name: '' }" :options="statusOptions" />
      </div>
      <div class="flex sm6 md4 xl3 xs12">
        <va-select :label="$t('orders.perPage')" v-model="perPage" noClear
          :options="['10', '20', '50', '100', '200']" />
      </div>
      <div class="flex sm6 md4 xl2 xs12">
        <va-button @click="getScvOrders([])" style="white-space: nowrap;">export csv</va-button>
      </div>
    </div>
    <va-data-table ref="vuetable" :fields="fields" :data="items" :loading="loading && !skipLoading"
      :totalPages="totalPages" @page-selected="readItems" api-mode>
      <template slot="status" slot-scope="props">
        <div
          :style="{ background: `var(--va-${statusesColor[props.rowData.status]})`, color: 'white', padding: '5px', textAlign: 'center' }">
          {{ statuses[props.rowData.status] }}
        </div>
      </template>

      <template slot="actions" slot-scope="props">
        <div>
          <router-link :to="{ name: 'orders-single', params: { id: props.rowData.id } }">
            <va-button>{{  $t("orders.more")  }}</va-button>
          </router-link>
        </div>
      </template>
    </va-data-table>
  </va-card>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { debounce } from 'lodash'
import moment from 'moment'

export default {
  data() {
    return {
      deleteItem: null,
      skipLoading: false,
      searchBy: '',
      searchValue: '',
      statuses: {
        0: 'AWAITING',
        1: 'APPROVED',
        '-1': 'DECLINED',
        2: 'SENT',
        3: 'RECEIVED',
        4: 'RETURNED',
        '-2': 'CANCELLED',
      },
      statusesColor: {
        0: 'warning',
        1: 'success',
        '-1': 'danger',
        2: 'info',
        3: 'success',
        4: 'primary',
        '-2': 'gray',
      },
    }
  },
  computed: {
    statusOptions() {
      return Object.keys(this.statuses).map(e => ({ status: e, title: this.statuses[e] }))
    },
    ...mapState({
      loading: state => state.Orders.isLoading,
      limit: state => state.Orders.params.limit,
      totalPages: state => state.Orders.total_pages,
      items: state => state.Orders.items,
      page: state => state.Orders.params.page,
      status: state => state.Orders.params.status,
      ordersTotal: state => state.Orders.total_objects,
    }),
    filterByStatus: {
      get() {
        console.log(this.status)
        return (
          this.statusOptions.find(
            el => el.status === this.status,
          ) ?? {}
        )
      },
      set(value = {}) {
        console.log(value)
        this.readItems(this.page, this.limit, value.status ? value.status : '')
      },
    },
    perPage: {
      get() {
        return this.limit + ''
      },
      set(value) {
        this.readItems(1, value)
      },
    },
    fields() {
      return [
        {
          name: '__slot:status',
          title: this.$t('orders.status'),
          width: '60px',
        },

        {
          name: 'borrower',
          title: this.$t('orders.borrower'),
        },
        {
          name: 'publication.lender.get_full_name',
          title: this.$t('orders.lender'),
        },
        {
          name: 'publication.title',
          title: this.$t('orders.publication'),
        },
        {
          name: 'created_at',
          title: this.$t('orders.created_at'),
        },
        {
          name: 'updated_at',
          title: this.$t('orders.updated_at'),
        },
        {
          name: 'approved_at',
          title: this.$t('orders.approved_at'),
        },

        {
          name: '__slot:actions',
          title: this.$t('orders.totalCount') + this.ordersTotal,
          width: '60px',
          dataClass: 'text-center action-button',
        },
      ]
    },
  },
  watch: {
    searchValue: debounce(function () {
      this.readItems(1)
    }, 500),
    searchBy: function () {
      if (typeof this.searchBy === 'object') {
        this.searchBy = ''
      }
    },
  },
  created() {
    this.readItems()
  },
  methods: {
    moment,
    ...mapActions('Orders', ['getItems', 'block', 'unBlock', 'deleteUser', 'getScvOrders']),
    async readItems(
      page = this.page,
      limit = this.limit,
      status = this.status,
      searchBy = this.searchBy,
      searchValue = this.searchValue,
    ) {
      const req = { limit, page, status }
      if (searchBy && searchValue) {
        req[searchBy] = searchValue
      }

      const res = this.getItems(req)
      this.$nextTick(() => {
        this.$refs.vuetable.currentPage = page
      })
      return res
    },
    async blockingUser(id) {
      this.skipLoading = true
      const res = await this.block({
        id,
        data: { description: 'Block from list' },
      })
      if (res.data?.ok) {
        await this.readItems()
        this.showToast(res.data?.ok, {
          icon: 'fa-check',
          position: 'bottom-right',
          duration: 2500,
          fullWidth: false,
        })
      }
    },
    async deletingUser({ data, clear }) {
      const ask =
        data?.deleting &&
        confirm('Are you sure? Do you want to delete this order?')
      this.skipLoading = true

      if (ask || !data?.deleting) {
        const res = await this.deleteUser(data)
        if (res.data?.ok) {
          await this.readItems()
          this.showToast(res.data?.ok, {
            icon: 'fa-check',
            position: 'bottom-right',
            duration: 2500,
            fullWidth: false,
          })
        } else {
        }
        clear()
        this.deleteItem = null
        this.skipLoading = false
      }
      // this.$router.go(-1)
    },
    async unBlockingUser(id) {
      this.skipLoading = true
      const res = await this.unBlock(id)
      if (res.data?.ok) {
        await this.readItems()
        this.showToast(res.data?.ok, {
          icon: 'fa-check',
          position: 'bottom-right',
          duration: 2500,
          fullWidth: false,
        })
      }
    },
  },
}
</script>

<style lang="scss">
.orders__avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.action-button {
  white-space: nowrap;
}

.serchby {
  min-width: 200px;

  @media (max-width: 700px) {
    min-width: 150px;
  }

  @media (max-width: 400px) {
    min-width: 100px;
  }

  .va-select {
    border-bottom: none;
    border-right-width: 1px;
    border-top-right-radius: 0;
  }
}

th.vuetable-th-slot-actions {
  font-size: 30px;
  text-align: right;
  color: var(--va-textColor);
}
</style>
